// internationalization
import type { TFunction } from 'i18next';

// api
import type { UtilityProvider } from '@/api/generated/energyAnalysis/endpoints/utilityProviders';

// libraries
import { z } from 'zod';

export type { UtilityProvider };

export function createEditMeterUtilityProviderFormSchema(t: TFunction) {
  return z.object({
    provider: z.custom<UtilityProvider | null>().refine((v) => v !== null, {
      message: t('input.required', { ns: 'validation' }),
    }),
  });
}

export type EditMeterUtilityProviderFormValues = z.infer<
  ReturnType<typeof createEditMeterUtilityProviderFormSchema>
>;
